const actions = {
  CRAWL_EXTRACT_SELLING_PRICE_REQUEST: "CRAWL_EXTRACT_SELLING_PRICE_REQUEST",
  CRAWL_EXTRACT_SELLING_PRICE_SUCCESS: "CRAWL_EXTRACT_SELLING_PRICE_SUCCESS",
  CRAWL_EXTRACT_SELLING_PRICE_ERROR: "CRAWL_EXTRACT_SELLING_PRICE_ERROR",

  GET_CRAWL_EXTRACT_SELLING_PRICE_REQUEST: "GET_CRAWL_EXTRACT_SELLING_PRICE_REQUEST",
  GET_CRAWL_EXTRACT_SELLING_PRICE_SUCCESS: "GET_CRAWL_EXTRACT_SELLING_PRICE_SUCCESS",
  GET_CRAWL_EXTRACT_SELLING_PRICE_ERROR: "GET_CRAWL_EXTRACT_SELLING_PRICE_ERROR",

  crawlExtractSellingPrice: (payload) => ({
    type: actions.CRAWL_EXTRACT_SELLING_PRICE_REQUEST,
    payload,
  }),

  getCrawlExtractSellingPrice: (payload) => ({
    type: actions.GET_CRAWL_EXTRACT_SELLING_PRICE_REQUEST,
    payload,
  }),
};
export default actions;
